export const INTERNET_ACCESS_CHECK_URL = 'https://connectivitycheck.gstatic.com/generate_204';

/**
 * Requests a lightweight endpoint outside PointCraft's infrastructure.
 *
 * The opaque `no-cors` response intentionally proves only that the request
 * reached an external origin. PointCraft availability remains authoritative
 * and is validated separately by the connectivity coordinator.
 */
export async function requestInternetAccessProbe(signal: AbortSignal): Promise<void> {
  await fetch(INTERNET_ACCESS_CHECK_URL, {
    method: 'GET',
    mode: 'no-cors',
    cache: 'no-store',
    credentials: 'omit',
    signal,
  });
}
